module.exports = __webpack_public_path__ + "static/media/master.f92452fe.svg";